import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Box, Heading, Link, Text } from '@chakra-ui/react';
import './Dashboard.css';

const copy = {
    hiringGuide: {
        header: 'Guides to Getting Hired 📚',
        body: 'We’ve compiled data on hundreds of top companies and internship programs to give you the hiring insights that’ll help you land your dream role.',
        buttonText: 'Browse company guides',
        buttonLink: 'https://www.pathmatch.com/companies'
    }
};

export default function HiringGuide() {
    return (
        <Box className="boxContent">
            <Heading className="boxHeading" fontSize={{ base: '22px' }}>
                {copy.hiringGuide.header}
            </Heading>
            <Text mt="2" mb="2" fontSize={{ base: '14px' }} lineHeight={{ base: '24px' }}>
                {copy.hiringGuide.body}
            </Text>
            <Link href={copy.hiringGuide.buttonLink} isExternal>
                {copy.hiringGuide.buttonText}
                <ExternalLinkIcon mx="4px" />
            </Link>
        </Box>
    );
}
